/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import Fuse from 'fuse.js';
import { IFilterData } from 'redux/filterDataType';
import { ISoftware } from '@umati/dashboard-types';
import { FilterSpec, FilterFair, FilterHalls, FilterFavourite, Filter } from 'utilities/Filter';

export interface IFilterSoftwareData extends IFilterData {

}

const searchKeys = [
  'name',
  'Data.Manufacturer.text',
  'demoPageShortUrl',
  'demoPageUrl'
];
const fuseOptions = { keys: searchKeys, includeScore: true, threshold: 0.4 };
export const FilterMachineFuzzySearch = new FilterSpec<ISoftware, IFilterSoftwareData>(
  'FuzzySearch',
  (element, searchValue?: string) => {
    const fuse = new Fuse(element, fuseOptions);
    if (typeof searchValue !== 'string' || searchValue === '') {
      return element;
    }
    return fuse.search(searchValue).map(m => m.item);
  },
  'searchValue'
);

const SoftwareFilters : FilterSpec<ISoftware, IFilterSoftwareData>[] = [
  FilterFair<ISoftware, IFilterSoftwareData>(),
  FilterHalls<ISoftware, IFilterSoftwareData>(),
  FilterFavourite<ISoftware, IFilterSoftwareData>(),
  FilterMachineFuzzySearch
];

export class SoftwareFilter extends Filter<ISoftware, IFilterSoftwareData> {
  constructor (filterData: IFilterSoftwareData) {
    super(filterData, SoftwareFilters);
  }
}
